import React from "react";
import Routes from "../routes/";
import { Router } from "react-router-dom";
import history from "../utils/history";
import GlobalStyle from "../styles/global";
import { ThemeProvider } from "styled-components";
import theme from "../styles/theme";
import { ToastContainer } from "react-toastify";
import * as Auth from "../context/globalContext";

function App() {
  return (
    <>
      <Auth.Provider>
        <ThemeProvider theme={theme}>
          <Router history={history}>
            <ToastContainer autoClose={3000} />
            <GlobalStyle />
            <Routes />
          </Router>
        </ThemeProvider>
      </Auth.Provider>
    </>
  );
}

export default App;
